"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _utils = require("../utils");
var createOrderStatusChecker = function createOrderStatusChecker(_ref) {
  var _sys$contentType;
  var sys = _ref.sys,
    fields = _ref.fields;
  return {
    id: (0, _utils.getProp)(sys, 'id'),
    contentType: (0, _utils.getProp)(sys === null || sys === void 0 ? void 0 : (_sys$contentType = sys.contentType) === null || _sys$contentType === void 0 ? void 0 : _sys$contentType.sys, 'id'),
    site: (0, _utils.getProp)(fields, 'site'),
    title: (0, _utils.getProp)(fields, 'title'),
    inputPlaceholder: (0, _utils.getProp)(fields, 'inputPlaceholder'),
    ctaText: (0, _utils.getProp)(fields, 'ctaText'),
    statusRefused: (0, _utils.getProp)(fields, 'statusRefused'),
    statusPreparing: (0, _utils.getProp)(fields, 'statusPreparing'),
    statusReviewed: (0, _utils.getProp)(fields, 'statusReviewed'),
    statusDispatchingSoon: (0, _utils.getProp)(fields, 'statusDispatchingSoon'),
    statusDispatched: (0, _utils.getProp)(fields, 'statusDispatched'),
    statusUnaccountedFor: (0, _utils.getProp)(fields, 'statusUnaccountedFor'),
    statusConfirmedDelivery: (0, _utils.getProp)(fields, 'statusConfirmedDelivery'),
    statusProcessing: (0, _utils.getProp)(fields, 'statusProcessing'),
    statusUnknown: (0, _utils.getProp)(fields, 'statusUnknown')
  };
};
var _default = createOrderStatusChecker;
exports["default"] = _default;